module.exports = __webpack_public_path__ + "static/media/82EAB490-1058-43B6-85F8-83DBA727EECC.b797cab5.png";